import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ColumnSettingsActionName } from 'src/app/shared/model/column-settings-action';
import { ColumnVisabilityPositionSetting } from 'src/app/shared/model/data-source';
import { SummaryType } from 'src/app/shared/model/summary-type';
import { GroupingColumnSelectorComponent } from '../../column-options/grouping-column-selector/grouping-column-selector.component';
import { SelectedEvent } from '../../column-options/column-hider-list/column-hider-list.component';
import { ResourceUUIDVersionIdentifier } from 'src/app/common/model/resource-id-version-identifier';

@Component({
  selector: 'app-column-settings-dialog',
  templateUrl: './column-settings-dialog.component.html',
  styleUrls: ['./column-settings-dialog.component.scss']
})

export class ColumnSettingsDialogComponent implements AfterViewInit {

  // Workaround for angular component issue #13870
  disableAnimation = true;
  idSetColumnsSelected: ResourceUUIDVersionIdentifier | null;
  private mappedColumnNames: ColumnVisabilityPositionSetting[] = [];
  // zmiany przypięcia kolumn są buforowane i stosowane dopiero przy zapisie
  pendingFrozenColumnsCount: number | null;

  @ViewChild('groupingColumnSelector') groupingColumnSelector?: GroupingColumnSelectorComponent;

  constructor(public dialogRef: MatDialogRef<ColumnSettingsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.mappedColumnNames = this.data.columnsSettings;
    this.pendingFrozenColumnsCount = this.data.frozenColumnsCount ?? null;
  }

  onFrozenColumnsCountChange(count: number | null): void {
    this.pendingFrozenColumnsCount = count;
  }

  ngAfterViewInit(): void {
    const availableColumns = this.filterAvailableToGroup(this.data.columnsSettings);
    this.groupingColumnSelector?.setAvailableColumns(availableColumns);
    setTimeout(() => this.disableAnimation = false);
  }

  filterAvailableToGroup(settings: ColumnVisabilityPositionSetting[]): { name: string; title: string }[] {
    return this.data.possibleToGrouping.filter((p: { name: string }) => settings.some(s => s.isVisible && s.columnName === p.name));
  }

  save(): void {
    const actionsData: Map<ColumnSettingsActionName, any> = new Map<ColumnSettingsActionName, any>();
    actionsData.set(ColumnSettingsActionName.HIDE_COLUMNS, this.mappedColumnNames);
    let groupingColumn: string = null;
    if (this.selectedGroupingColumn && this.selectedGroupingColumn != '')
      groupingColumn = this.selectedGroupingColumn;
    actionsData.set(ColumnSettingsActionName.SELECT_GROUPING_COLUMN, groupingColumn);
    actionsData.set(ColumnSettingsActionName.FREEZE_COLUMNS, this.pendingFrozenColumnsCount);
    this.dialogRef.close({ actions: actionsData });
    if (this.data.summaryEnabled && !this.data.displayFooter)
      actionsData.set(ColumnSettingsActionName.DISABLE_SUMMARY, this.data.displayFooter);
    if (this.data.summaryEnabled && this.data.displayFooter)
      actionsData.set(ColumnSettingsActionName.ENABLE_AND_SELECT_SUMMARY_TYPE, { displayFooter: this.data.displayFooter, type: this.data.summaryType });

    actionsData.set(ColumnSettingsActionName.SET_OF_COLUMNS_SELECTED, this.idSetColumnsSelected);
  }

  resetSettings(): void {
    const actionsData: Map<ColumnSettingsActionName, any> = new Map<ColumnSettingsActionName, any>();
    actionsData.set(ColumnSettingsActionName.RESET_SETTINGS, null);
    this.dialogRef.close({ actions: actionsData });
  }

  private get selectedGroupingColumn(): string | null {
    return this.groupingColumnSelector?.selectedGroupingColumn;
  }

  summaryTypeChange(event: SummaryType): void {
    this.data.summaryType = event;
    this.data.displayFooter = event != null;
  }

  setColsVisabilityState(event: SelectedEvent): void {
    const availableToGroup = this.filterAvailableToGroup(event.value);
    this.groupingColumnSelector?.onVisibilityChanged(availableToGroup);
    this.mappedColumnNames = event.value;
    this.idSetColumnsSelected = event.idSelectedSet;
  }

  isFormDisabled(): boolean {
    return this.mappedColumnNames.find(v => v.isVisible === true) == null;
  }

}
